module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_3D_models-0da95d515158151307b13d6c91aab656.png";